import React from 'react'

function StatusPill(props) {
const status = props.status;
  return (
    <div style={{
        // border:"1px dashed red",
        maxHeight:"30px"
    }}>
        <div className='center' style={{
            borderRadius:"20px",
            padding:'6px 10px',
            fontSize:"12px",
            background:`${
                status === 'unfixed'
                ?"#FEE2E2"
                :status === 'pending'
                ?"#FEF9C3"
                :"#DCFCE7"
            }`,
            color:`${ status === 'unfixed'
                ?"#7F1D1D"
                :status === 'pending'
                ?"#713F12"
                :"#14532D"}`
        }}>
            {/* <i className='material-icons' style={{
                fontSize:"8px",
                padding:"0px 4px",
            }}>fiber_manual_record</i> */}
            {status}
        </div>
    </div>
  )
}

export default StatusPill